<style src="./style.scss">
</style>

<script lang="ts">
  export let title;
  export let background;
  export let active = false;
  export let onClick = () => null;

  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" +
            Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(
              16
            )
          ).substr(-2)
        )
    );
  }

  const shadowColor = adjust(background, -40);
</script>

<div
  class="plan"
  style="
    --background: {active ? shadowColor : '#e4e4e4'};
    background: {active
    ? background
    : 'white'};
    border: solid 1px {active
    ? shadowColor
    : '#E4E4E4'};
    color: {active ? '#1a1a1a' : '#656565'}"
  on:click="{onClick}">
  {title}
</div>
